
import './LeadrOrder.scss'
import RequestDetail from '../../RequestDetail';
import AttachmentLinkContainer from 'client/Components/OrderManagement/ApprovalOrder/LeadrOrder/ItemDetail/AttachmentLink/AttachmentLink-Container';

const LeaderOrder = (props?: any) => {
  const transferOrderByIdData = props?.transferOrderByIdData

  const requestDetails =  transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => detailsByIdItem)
    return (
    <div className="LeaderOrder mt-1 p-3">
      <div>
        <div className="blueLabel pull-left">Request Details</div>
        <div className='pull-right'>
          <AttachmentLinkContainer
             requesttype={props.requesttype}
             item={transferOrderByIdData}
             index={props.index}
             itemLevel = {"Order"}
          />
        </div>   
      </div> 
      <RequestDetail transferOrderByIdData = {transferOrderByIdData} requesttype = {props?.requesttype} detailsByIdItem={requestDetails?.pop()} />
      
    </div>
)}

export default LeaderOrder;